<div
  class="sd-container--variant-white"
  [ngClass]="{ 'sd-container': userFundsSelectionVisible, prelogon: !userFundsSelectionVisible }">
  <wct-fonds-filters
    #filters
    [documentId]="cuid()"
    [filterSelections]="selection"
    [hiddenFilters]="hiddenFilters"/>

  <div class="searchbar">
    <sd-4-5-1-input
      placeholder="{{ 'advancedFundList.searchPlaceholder' | transloco }}"
      size="md"
      [clearable]="true"
      [wctSdSignalModel]="searchTerm"></sd-4-5-1-input>

    <sd-4-5-1-button
      (click)="filters.show()"
      size="md">

      {{ 'advancedFundList.filter' | transloco }}

      <sd-4-5-1-icon
        slot="icon-right"
        library="{{ iconLibrary }}"
        name="system/filter-empty"></sd-4-5-1-icon>

    </sd-4-5-1-button>
  </div>

  @if (selectedFilters().length) {
    <wct-spacer [spacingAmount]="0.5"/>

    <sd-4-5-1-scrollable [buttons]="true">
      <div class="selected-filters">
        @for (option of selectedFilters(); track $index) {
          <sd-4-5-1-tag>

            <span>{{ option.groupName }} | {{ option.valuesText }}</span>

            <sd-4-5-1-icon
              library="system"
              name="closing-round"
              (click)="removeSelectedFilter(option.groupName)">
            </sd-4-5-1-icon>
          </sd-4-5-1-tag>
        }
      </div>
    </sd-4-5-1-scrollable>
  }

  <wct-spacer/>

  @if (userFundsSelectionVisible) {
    <sd-4-5-1-radio-group
      size="sm" [value]="fundsVisibility()">

      <sd-4-5-1-tooltip
        trigger="hover focus"
        placement="top"
        content="{{ 'advancedFundList.ownFundsTooltip' | transloco }}"
      >
        <sd-4-5-1-radio-button
          value="user"
          (click)="fundsVisibility.set('user')">
          <span>{{ 'advancedFundList.ownFunds' | transloco }}</span>
        </sd-4-5-1-radio-button>
      </sd-4-5-1-tooltip>

      <sd-4-5-1-tooltip
        trigger="hover focus"
        placement="top"
        content="{{ 'advancedFundList.specialFundsTooltip' | transloco }}"
      >
        <sd-4-5-1-radio-button
          value="special"
          (click)="fundsVisibility.set('special')">
          <span>{{ 'advancedFundList.specialFunds' | transloco }}</span>
        </sd-4-5-1-radio-button>
      </sd-4-5-1-tooltip>

      <sd-4-5-1-tooltip
        trigger="hover focus"
        placement="top"
        content="{{ 'advancedFundList.publicFundsTooltip' | transloco }}"
      >
        <sd-4-5-1-radio-button
          value="public"
          (click)="fundsVisibility.set('public')">
          <span>{{ 'advancedFundList.publicFunds' | transloco }}</span>
        </sd-4-5-1-radio-button>
      </sd-4-5-1-tooltip>
    </sd-4-5-1-radio-group>

    <wct-spacer/>
  }

  <app-bo-table
    *rptHandleErrors
    (tableData)="checkLoadedData($event)"
    [documentId]="cuid()"
    [filterSelections]="tableFilterSelections"
    [searchTerm]="searchTerm"
    [actionHandler]="actionHandler">

    <wct-no-search-results
      no-results
      (resetClick)="resetSearchAndFilters()"/>

    <div empty>
      @if (hadDataBefore()) {
        <wct-no-search-results (resetClick)="resetSearchAndFilters()"/>
      } @else {
        <wct-no-search-results
          [icon]="'system/info-circle'"
          [headline]="'fondsOverview.noFunds.header' | transloco"
          [message]="'fondsOverview.noFunds.message' | transloco"
          [displayResetButton]="false"/>
      }
    </div>

  </app-bo-table>
</div>

<wct-advanced-fond-list-drawer
  [redirectUrl]="redirectUrl"
  [showPublicDocuments]="!userFundsSelectionVisible"
  [showUserQuicklinks]="userFundsSelectionVisible"/>
